export interface DrawerTheme {
  /** CSS class applied to the root drawer container. */
  base: string;
  /** CSS classes applied to the drawer header and its text. */
  header: {
    base: string;
    text: string;
  };
  /** CSS class applied to the drawer content area. */
  content: string;
  /** CSS class applied to the drawer footer. */
  footer: string;
  /** CSS class applied when padding is disabled. */
  disablePadding: string;
  /** CSS classes applied to the drawer close button. */
  closeButton: {
    base: string;
    headerless: string;
  };
  /** CSS classes applied for each drawer position. */
  positions: {
    top: string;
    end: string;
    bottom: string;
    start: string;
  };
}

const baseTheme: DrawerTheme = {
  base: 'fixed overflow-y-auto overflow-x-hidden',
  header: {
    base: 'flex items-center justify-between px-8 py-5 text-3xl font-bold',
    text: 'flex-1 m-0'
  },
  content: 'px-8 py-5 flex-1 overflow-auto',
  footer: 'flex px-8 py-5 mt-auto',
  disablePadding: 'p-0',
  closeButton: {
    base: 'opacity-80 h-auto w-auto min-w-[auto] min-h-[auto] cursor-pointer text-base p-0 border-0 focus:outline-hidden',
    headerless: 'absolute right-5 top-5'
  },
  positions: {
    top: 'w-full inset-x-0 top-0',
    end: 'h-full inset-y-0 right-0',
    bottom: 'w-full inset-x-0 bottom-0',
    start: 'h-full inset-y-0 left-0'
  }
};

export const drawerTheme: DrawerTheme = {
  ...baseTheme,
  base: [baseTheme.base, 'bg-panel text-text-primary'].join(' ')
};
